import initState from "./initState";

import * as types from "./types";
import { updateObject, deepClone, removeItem, createNumberRange } from "utils";

function fetchBackupPlansStart(state, action) {
  return updateObject(state, {
    backupPlans: updateObject(state.backupPlans, {
      loading: true,
      checkList: []
    })
  });
}

function fetchBackupPlansSuccess(state, action) {
  let updatedBackupPlans = {};
  for (let val of action.data) {
    if (val.planId) {
      if (val.scheduleInfo.type === 1)
        val.scheduleInfo.weekDays = createNumberRange(7, 0);
      updatedBackupPlans[val.planId] = val;
    }
  }
  return updateObject(state, {
    backupPlans: updateObject(state.backupPlans, {
      loading: false,
      data: updatedBackupPlans
    })
  });
}

function fetchBackupPlansSettingStart(state, action) {
  return updateObject(state, {
    backupPlanSettings: updateObject(state.backupPlanSettings, {
      loading: true,
      data: {},
      updated: false
    }),
    cachePlanSettings: {}
  });
}

function fetchBackupPlansSettingSuccess(state, action) {
  if (action.data.status !== 3) {
    const updatedBackupPlansData = { ...state.backupPlans.data };
    if (action.data.devices.length !== 0) {
      const clientUUIDs = action.data.devices.map(dev => dev.clientUUID);
      let plans = Object.values(updatedBackupPlansData).filter(
        data => data.status !== 3
      );
      plans.forEach(plan => {
        updatedBackupPlansData[plan.planId].devices = updatedBackupPlansData[
          plan.planId
        ].devices.filter(dev => !clientUUIDs.includes(dev.clientUUID));
      });
    }
    updatedBackupPlansData[action.data.planId].devices = action.data.devices;

    return updateObject(state, {
      backupPlanSettings: updateObject(state.backupPlanSettings, {
        loading: false,
        data: action.data
      }),
      cachePlanSettings: action.data,
      backupPlans: updateObject(state.backupPlans, {
        data: updateObject(state.backupPlans.data, updatedBackupPlansData)
      })
    });
  } else
    return updateObject(state, {
      backupPlans: updateObject(state.backupPlans, {
        data: updateObject(state.backupPlans.data, {
          [action.data.planId]: updateObject(
            state.backupPlans.data[action.data.planId],
            { status: action.data.status }
          )
        })
      })
    });
}

function setCleanBackupPlanCache(state, action) {
  return updateObject(state, {
    cachePlanSettings:
      action.planId === "defaultPlanDetails"
        ? state.defaultPlanDetails
        : state.backupPlans.data[action.planId]
  });
}

function cleanBackupPlanCache(state, action) {
  return updateObject(state, {
    [action.key]: null
  });
}

function saveBackupPlansSettingStart(state, action) {
  return updateObject(state, {
    settings: {
      loading: true,
      updated: false
    }
  });
}

function saveBackupPlansSettingSuccess(state, action) {
  let updatedPlan = JSON.parse(
    JSON.stringify(state.backupPlans.data[action.data.planId])
  );

  //checking if conflict is there
  let tempPlans = { ...state.backupPlans.data };

  let isConflict = false;
  for (let val of action.data.devices) {
    if (JSON.stringify(tempPlans).includes(val.clientUUID)) {
      isConflict = true;
      break;
    }
  }
  let plansArray = [];
  //updating the plans list if conflict is there
  if (isConflict) {
    plansArray = Object.values(tempPlans).map(plan => {
      let index = action.data.devices.flatMap(dev =>
        plan.devices.map(dev1 => dev1.clientUUID).indexOf(dev.clientUUID)
      );
      index.sort().reverse();
      for (let i = 0; i < index.length; i++) {
        if (index[i] > -1) {
          plan.devices.splice(index[i], 1);
        }
      }
      return plan;
    });
    tempPlans = {};
    for (let val of plansArray) {
      if (val.planId) {
        tempPlans[val.planId] = val;
      }
    }
  }

  for (let val of Object.keys(action.data)) {
    if (val !== "planId") {
      updatedPlan[val] = action.data[val];
    }
  }

  tempPlans[updatedPlan.planId] = updatedPlan;

  return updateObject(state, {
    backupPlans: updateObject(state.backupPlans, {
      data: tempPlans
    }),
    settings: {
      loading: false,
      updated: true
    }
  });
}

function toggleBackupPlansCheckList(state, action) {
  let updatedCheckList = state.backupPlans.checkList
    ? [...state.backupPlans.checkList]
    : [];
  if (updatedCheckList.includes(action.planId)) {
    updatedCheckList = removeItem(
      updatedCheckList,
      updatedCheckList.indexOf(action.planId)
    );
  } else {
    updatedCheckList.push(action.planId);
  }

  return updateObject(state, {
    backupPlans: updateObject(state.backupPlans, {
      checkList: updatedCheckList
    })
  });
}

function changeBackupPlansCheckList(state, action) {
  return updateObject(state, {
    backupPlans: updateObject(state.backupPlans, {
      checkList: action.data
    })
  });
}

function disableBackupPlanSuccess(state, action) {
  const updatedBackupPlanData = state.backupPlans.data;
  if (action.data.planIDs) {
    action.data.planIDs.forEach(element => {
      updatedBackupPlanData[element].status = 2;
    });
  }
  return updateObject(state, {
    backupPlans: updateObject(state.backupPlans, {
      data: updatedBackupPlanData
    })
  });
}

function enableBackupPlanSuccess(state, action) {
  const updatedBackupPlanData = state.backupPlans.data;
  if (action.data.planIDs) {
    action.data.planIDs.forEach(element => {
      updatedBackupPlanData[element].status = 1;
    });
  }
  return updateObject(state, {
    backupPlans: updateObject(state.backupPlans, {
      data: updatedBackupPlanData
    })
  });
}

function deleteBackupPlanSuccess(state, action) {
  const updatedBackupPlanData = state.backupPlans.data;
  if (action.data.planIDs) {
    action.data.planIDs.forEach(element => {
      updatedBackupPlanData[element].status = 3;
    });
  }
  return updateObject(state, {
    backupPlans: updateObject(state.backupPlans, {
      data: updatedBackupPlanData,
      checkList: []
    })
  });
}

function createNewBackupPlanStart(state, action) {
  return updateObject(state, {
    settings: {
      loading: true,
      updated: false
    }
  });
}

function createNewBackupPlanSuccess(state, action) {
  return updateObject(state, {
    settings: {
      loading: false,
      createdNewBackup: true
    },
    backupPlans: updateObject(state.backupPlans, {
      checkList: []
    })
  });
}

function resetLoadingSettings(state, action) {
  return updateObject(state, {
    settings: {
      loading: false,
      createdNewBackup: false,
      updated: false
    }
  });
}

function fetchDefaultPlanToCreatePlanStart(state, action) {
  return updateObject(state, {
    settings: {
      loading: true,
      createdNewBackup: false,
      updated: false
    }
  });
}

function fetchDefaultPlanToCreatePlanSuccess(state, action) {
  let defaultPlanDetails = { ...action.data };
  if (defaultPlanDetails.scheduleInfo?.type === 1)
    defaultPlanDetails.scheduleInfo.weekDays = createNumberRange(7, 0);
  return updateObject(state, {
    defaultPlanDetails,
    settings: {
      loading: false,
      updated: false
    }
  });
}

function saveBackupPlansSettingFailure(state, action) {
  return updateObject(state, {
    settings: {
      loading: false,
      updated: true,
      createdNewBackup: true
    }
  });
}

function backupPlansAPIDown(state, action) {
  return updateObject(state, {
    backupPlans: updateObject(state.backupPlans, {
      loading: false,
      failed: {
        msg: action.data.msg,
        status: action.data.status
      }
    })
  });
}

function editDefaultPlan(state, action) {
  return updateObject(state, {
    editDefaultplan: action.data
  });
}

function reducer(state = deepClone(initState), action) {
  switch (action.type) {
    case types.FETCH_BACKUP_PLANS_START:
      return fetchBackupPlansStart(state, action);
    case types.FETCH_BACKUP_PLANS_SUCCESS:
      return fetchBackupPlansSuccess(state, action);
    case types.TOGGLE_BACKUP_PLANS_CHECKLIST:
      return toggleBackupPlansCheckList(state, action);
    case types.DISABLE_BACKUP_PLAN_SUCCESS:
      return disableBackupPlanSuccess(state, action);
    case types.ENABLE_BACKUP_PLAN_SUCCESS:
      return enableBackupPlanSuccess(state, action);
    case types.DELETE_BACKUP_PLAN_SUCCESS:
      return deleteBackupPlanSuccess(state, action);
    case types.FETCH_BACKUP_PLANS_SETTING_START:
      return fetchBackupPlansSettingStart(state, action);
    case types.FETCH_BACKUP_PLANS_SETTING_SUCCESS:
      return fetchBackupPlansSettingSuccess(state, action);
    case types.SAVE_BACKUP_PLANS_SETTING_START:
      return saveBackupPlansSettingStart(state, action);
    case types.SAVE_BACKUP_PLANS_SETTING_SUCCESS:
      return saveBackupPlansSettingSuccess(state, action);
    case types.CLEAN_BACKUP_PLAN_CACHE:
      return cleanBackupPlanCache(state, action);
    case types.SET_CLEAN_BACKUP_PLAN_CACHE:
      return setCleanBackupPlanCache(state, action);
    case types.CREATE_NEW_BACKUP_PLAN_START:
      return createNewBackupPlanStart(state, action);
    case types.CREATE_NEW_BACKUP_PLAN_SUCCESS:
      return createNewBackupPlanSuccess(state, action);
    case types.RESET_LOADING_SETTINGS:
      return resetLoadingSettings(state, action);
    case types.FETCH_DEFAULT_BACKUP_PLAN_TO_CREATE_PLAN_START:
      return fetchDefaultPlanToCreatePlanStart(state, action);
    case types.FETCH_DEFAULT_BACKUP_PLAN_TO_CREATE_PLAN_SUCCESS:
      return fetchDefaultPlanToCreatePlanSuccess(state, action);
    case types.SAVE_BACKUP_PLAN_SETTINGS_FAILURE:
      return saveBackupPlansSettingFailure(state, action);
    case types.CHANGE_BACKUP_PLANS_CHECKLIST:
      return changeBackupPlansCheckList(state, action);
    case types.BACKUP_PLANS_API_DOWN:
      return backupPlansAPIDown(state, action);
    case types.EDIT_DEFAULT_PLAN:
      return editDefaultPlan(state, action);
    default:
      return state;
  }
}

export default reducer;
